/** 175.8M → "170M+" (never overstates). */
export function millionsFloor(n: number): string {
  return `${Math.floor(n / 10_000_000) * 10}M+`;
}

/** 217.3M → "220M". */
export function millionsRounded(n: number): string {
  return `${Math.round(n / 10_000_000) * 10}M`;
}

const FRACTIONS: ReadonlyArray<[number, string]> = [
  [1 / 4, 'a quarter'],
  [1 / 3, 'a third'],
  [1 / 2, 'half'],
  [2 / 3, 'two-thirds'],
  [3 / 4, 'three-quarters'],
  [9 / 10, 'nine-tenths'],
];

/** 0.649 → "about two-thirds". */
export function approxShare(share: number): string {
  let best = FRACTIONS[0] ?? [0, ''];
  for (const f of FRACTIONS) if (Math.abs(f[0] - share) < Math.abs(best[0] - share)) best = f;
  return `about ${best[1]}`;
}
